export default __webpack_public_path__ + "static/media/vee~bpOgYUiM.c4816300.svg";